import { useState } from "react";
import DelegationPermissionBadges from "../../delegation/DelegationPermissionBadges";
import { DelegationInvitationListItemModel } from "../../../interfaces/delegation";
import { formatDanishDateTime } from "../../../util/date";
import RevokeDelegationInvitationModal from "./RevokeDelegationInvitationModal";

interface DelegationInvitationsTableProps {
  invitations: DelegationInvitationListItemModel[];
}

const DelegationInvitationsTable = ({
  invitations,
}: DelegationInvitationsTableProps) => {
  const [revokeTarget, setRevokeTarget] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (invitations.length === 0) {
    return <p className="text-muted mb-0">Ingen afventende invitationer.</p>;
  }

  return (
    <>
      {error ? (
        <div className="alert alert-danger mb-3" role="alert">
          {error}
        </div>
      ) : null}
      <div className="table-responsive">
        <table className="table table-sm align-middle mb-0">
          <thead>
            <tr>
              <th scope="col">Modtager</th>
              <th scope="col">Betegnelse</th>
              <th scope="col">E-mail</th>

              <th scope="col">Rettigheder</th>
              <th scope="col">Udløber</th>
              <th scope="col" className="text-end">
                Handling
              </th>
            </tr>
          </thead>
          <tbody>
            {invitations.map((invitation) => (
              <tr key={invitation.id}>
                <td>{invitation.invitedName || "—"}</td>
                <td>{invitation.invitedLabel || "—"}</td>
                <td>{invitation.deliveryEmail || "—"}</td>
                <td>
                  <DelegationPermissionBadges
                    permissions={invitation.permissions}
                  />
                </td>
                <td>{formatDanishDateTime(invitation.expiresAt)}</td>
                <td className="text-end">
                  <button
                    type="button"
                    id={`delegation-revoke-invitation-${invitation.id}`}
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => setRevokeTarget(invitation.id)}
                    disabled={revokeTarget !== null}
                  >
                    Tilbagekald
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <RevokeDelegationInvitationModal
        invitationId={revokeTarget}
        onInvitationIdChange={setRevokeTarget}
        onError={setError}
      />
    </>
  );
};

export default DelegationInvitationsTable;
